<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditTimesheet
			v-if="timesheet_item"
			:editItem="timesheet_item"
			:color="'#81CC00'"
			:isAddTimesheet="is_clone"
			:isLogTimesheet="true"
			@cancel-timesheet="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditTimesheet from "@/views/timesheets/new_timesheet.vue";

export default {
	name: 'EditTimesheetDialog',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: false,
			error_msg: '',

			timesheet_id: 0,
			timesheet_item: null,

			is_clone: false
		}
	},
	components: {
		EditTimesheet
	},
	created() {
		this.timesheet_id = Number(this.$route.params.evid);

		if (this.$route.query.clone) {
			if (this.$route.query.clone === 'true') {
				this.is_clone = true;
			}
		}

		this.getTimesheet(this.timesheet_id);
	},
	methods: {
		async getTimesheet(id) {
			this.loading = true;

			const url = `/api/timesheets/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						this.timesheet_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>


